// @ts-ignore
// @ts-nocheck
import axios from 'axios';
import { toast } from 'react-toastify';
import localStorageService from './LocalStorageService';
import { scanHeaders } from './scanHeaders';

let continueWithRefreshToken = true;

const api = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': 'pt-BR',
    client_id: process.env.REACT_APP_CLIENT_ID,
    // ...(localStorage.getItem('@UltragazEmpresarial:accessToken') && {
    //   access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    // }),
    ...scanHeaders,
  },
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  function (config) {
    const userId = localStorage.getItem('@UltragazEmpresarial:userId');
    const urlAlterPassword = `industrial/customer/v1/users/${userId}/passwords`;
    const { url, method } = config;

    if (method === 'put' && url === urlAlterPassword) {
      continueWithRefreshToken = false;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      if (continueWithRefreshToken) return refreshToken();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const removeAllItemsLocalStorage = () => {
  localStorage.removeItem('@UltragazEmpresarial:customerCode');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
  localStorage.removeItem('@UltragazEmpresarial:customerName');
  localStorage.removeItem('@UltragazEmpresarial:refreshToken');
  localStorage.removeItem('@UltragazEmpresarial:accessToken');
  localStorage.removeItem('@UltragazEmpresarial:userName');
  localStorage.removeItem('@UltragazEmpresarial:document');
  localStorage.removeItem('@UltragazEmpresarial:customerId');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
  localStorage.removeItem('@UltragazEmpresarial:loginEmail');
  localStorage.removeItem('@UltragazEmpresarial:customerAddressLine');
  localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
  localStorage.removeItem('@UltragazEmpresarial:customerType');
};

async function refreshToken() {
  const req = axios.create({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };
  const parameters = {
    method: 'POST',
    headers: header,
  };
  const body = {
    grant_type: 'refresh_token',
    refresh_token: await localStorage.getItem(
      '@UltragazEmpresarial:refreshToken'
    ),
  };
  req
    .post('oauth/access-token', body, parameters)
    .then((res) => {
      if (res.status === 201) {
        const url_atual = window.location.href;
        window.location = url_atual;
        localStorageService.setToken(res.data);
      }
    })
    .catch((err) => {
      toast.error('Sua sessão foi expirada, faça login novamente no sistema!');
      window.location = '/acessar';
      removeAllItemsLocalStorage();
    });
}

export default api;
